import { EFeedbackChatbotModalActionTypes } from '../../actions/feedbackChatbotModal';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export const feedbackChatbotModalReducer = (state: TAppState, action: TReduxActions): TAppState => {
  switch (action.type) {
    case EFeedbackChatbotModalActionTypes.Open:
      return {
        ...state,
        feedbackChatbotModal: {
          ...state.feedbackChatbotModal,
          isOpened: true,
        },
      };

    case EFeedbackChatbotModalActionTypes.Close:
      return {
        ...state,
        feedbackChatbotModal: {
          ...state.feedbackChatbotModal,
          isOpened: false,
        },
      };

    case EFeedbackChatbotModalActionTypes.SetRating:
      return {
        ...state,
        feedbackChatbotModal: {
          ...state.feedbackChatbotModal,
          rating: action.payload,
        },
      };

    case EFeedbackChatbotModalActionTypes.SetComment:
      return {
        ...state,
        feedbackChatbotModal: {
          ...state.feedbackChatbotModal,
          comment: action.payload,
        },
      };

    case EFeedbackChatbotModalActionTypes.Reset:
      return {
        ...state,
        feedbackChatbotModal: {
          ...state.feedbackChatbotModal,
          rating: 0,
          comment: '',
        },
      };

    default:
      return state;
  }
};
